'use strict';
const { slickModalCarouselInit } = require('../product/initSlick');
var base = require('../product/base');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */

function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}
/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<button type="button" class="close pull-right" data-dismiss="modal">'
        + '    <span aria-hidden="true">&times;</span>'
        + '    <span class="sr-only"> </span>'
        + '</button>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer d-none"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            maskColorSize(5);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    }).done(function (){
        if($('#editProductModal .product-quickview .size-button a.size-selector-box').length == 1 && !$('#editProductModal .product-quickview .size-button a.size-selector-box').hasClass('selected')){
            $('#editProductModal .product-quickview .size-button a.size-selector-box').trigger('click');
            setTimeout(() => {
                $('#editProductModal .product-quickview .disabled-button-pdp').hide();
            }, 500);
        } else {
            if ($('#editProductModal .product-quickview .size-button a.size-selector-box').hasClass('selected') || $('#editProductModal .product-quickview .size-button a.size-selector-box').hasClass('active')) {
                $('#editProductModal .product-quickview .disabled-button-pdp').hide();
            }
        }
    });
}

function maskColorSize(length){
    var sizeLength = $('#editProductModal .product-quickview .size-selector-box').length;
    if (sizeLength > length) {
        $('#editProductModal .product-quickview span.more-size').removeClass('d-none');
        $('#editProductModal .product-quickview .size-button a.size-selector-box').hide();
        $('#editProductModal .product-quickview .size-button a.size-selector-box').slice(0, length).show();
    } else {
        $('#editProductModal .product-quickview span.more-size').addClass('d-none');
        $('#editProductModal .product-quickview .size-button a.size-selector-box').show();
    }

    var colorLength = $('.product-quickview .color-swatch-area .color-attribute').length;
    if (colorLength > length) {
        $('#editProductModal .product-quickview span.more-colors').removeClass('d-none');
        $('#editProductModal .product-quickview .color-swatch-area').find('.color-attribute').hide();
        $('#editProductModal .product-quickview .color-swatch-area').find('.color-attribute').slice(0, length).show();
    } else {
        $('#editProductModal .product-quickview span.more-colors').addClass('d-none');
        $('#editProductModal .product-quickview .color-swatch-area').find('.color-attribute').show();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}


/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

function cartModule() {    
    var cartRemove = 0;
    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        cartRemove++;
        $(document).ajaxComplete(function(event,xhr,options) {
            if (cartRemove === 1) {
                if (xhr.statusText && xhr.statusText === 'success') {
                    if(xhr.responseJSON.dataForGA) {
                        xhr.responseJSON.dataForGA.currentPage = window.location.href;
                        xhr.responseJSON.dataForGA.nextPage = window.location.href;
                        window.dataLayer.push(xhr.responseJSON.dataForGA);
                    }
                    $('body').trigger('sfmcAbandonedCartTrack', xhr.responseJSON.basket);
                    $.spinner().stop();
                    location.reload();
                } else {
                    if (xhr.statusText && xhr.statusText !== 'success' && !err.responseJSON.redirectUrl) {
                        if (!$(".remove-product").length) {
                            location.reload();
                        }
                    }
                }
        
                if (xhr.responseJSON && xhr.responseJSON.basket && xhr.responseJSON.basket.numItems === 0) {
                    location.reload();
                }

                cartRemove = 0;
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {

                // sync abandoned cart info
                $('body').trigger('sfmcAbandonedCartTrack', data);

            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.update-cart-product-global-new', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);
                    $('body').trigger('sfmcAbandonedCartTrack', data.cartModel);
                    $.spinner().stop();
                    location.reload();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
         e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
        setTimeout(function() {
            slickModalCarouselInit();
        }, 700);
    });
    
    $(document).ready(function () {
        const $ctaButton = $("#cta-button");
        const $footer = $("footer");
        const $stickyCTA = $(".sticky-cta");
        const stopPosition = $footer.offset().top - $stickyCTA.outerHeight();
        function updateStickyCTA() {
            const scrollY = $(window).scrollTop();
            const footerTop = $footer.offset().top;
            const viewportBottom = scrollY + $(window).height();
            
            if($('.empty-cart').length==0) {
                $stickyCTA.css({position: "fixed",top: "auto",display: "block"});
            }
        }
        $(window).on("scroll", updateStickyCTA);
        updateStickyCTA();
    });

    /* scroll to price detail section */
    $('.cta-view-details').on('click', function(e){
        e.preventDefault();
        var element = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(element).offset().top
        }, 300);
    });

    $(document).on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var url = $('.delete-coupon-confirmation-btn').data('action');
        var uuid = $('.delete-coupon-confirmation-btn').data('uuid');
        var couponCode = $('.delete-coupon-confirmation-btn').data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
                window.location.reload();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    }); 

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                    window.location.reload();
                } else {

                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    window.location.reload();
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $(document).on('click','.show-available-coupons', function (e) {
        e.preventDefault();
        let url = $(this).find('.available-coupons-link').data('url');
        $.spinner().start();
        $.ajax({
            url: url, 
            method: 'GET', 
            dataType: 'json', 
            success: function (data) {
                var couponList = $('#availableCoupons .coupons');
                couponList.empty(); 
                $.each(data.couponData, (index, coupon)=>{
                    window.datalayer=window.datalayer || []
                    const dl = Array.isArray(window.dataLayer) ? window.dataLayer : [];

                    // Find the latest view_cart with ecommerce.items
                    const latestViewCart = [...dl].reverse().find(
                    e => e && e.event === 'view_cart' && e.ecommerce && Array.isArray(e.ecommerce.items)
                    );

                    // Deep-clone to avoid accidental mutation of the original dataLayer object
                    const viewCartItems = latestViewCart ? JSON.parse(JSON.stringify(latestViewCart.ecommerce.items)) : [];

                    window.dataLayer.push({
                        event: 'view_promotion',
                        ecommerce: {
                            promotion_id: coupon.id,
                            promotion_name: coupon.description,
                            items: viewCartItems
                        }
                    });
                });
                    
                if (data.couponData.length > 0 ) {
                    $.each(data.couponData, (index, coupon)=>{
                        couponList.append(
                            '<tr>' +
                            '<td><span class="coupon-id btn js-coupon-apply" data-coupon="' + coupon.id + '">' + coupon.id + '</span></td>' +
                            '<td><span class="coupon-text">' + coupon.description + '</span></td>' +
                            '<td><a href="javascript:void(0)" class="coupon-apply-button js-coupon-apply btn-link-text"  data-coupon="' + coupon.id + '">Apply</a></td>' +
                            '</tr>'
                        );
                    });
                } else {
                    couponList.append(
                        '<tr>' +
                        '<td class="text-center">' + data.couponMsg + '</td>' +
                        '</tr>'
                    );
                }
                $.spinner().stop();
                // Show the modal
                $('#availableCoupons').modal('show');
            },
            error: function () {
                console.log('Error loading JSON data.');
            }
        });
    })    
    base.colorAttribute();
    base.selectAttribute();
    base.selectBonusProduct();
    base.showMoreBonusProducts();
    base.enableBonusProductSelection();
    base.removeBonusProduct();
    base.focusChooseBonusProductModal();
    base.addBonusProductsToCart();
    
    $(document).on('click','.coupons .js-coupon-apply', function (e) {
        var couponID = $(this).attr('data-coupon');
        $('.coupon-code-field').val(couponID);
        $('#availableCoupons').modal('hide');
        $('.promo-code-submit .promo-code-btn').trigger('click');
    });

    $(document).on('click','.promo-code-submit .promo-code-btn', function (e) {
        let couponID = $('#couponCode').val();
        let url = $('#customerNoUrl').val();
        let customerId;
        if (couponID) {
            $.ajax({
                url: url,
                dataType: 'json',
                method: 'GET',
                success(data) {
                    //if(data.customerId){
                        customerId = data.customerId;
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "Coupon_Apply",
                            click_text: couponID,
                            section_clicked: "couponCode_applied",
                            currentPage: window.location.href,
                            nextPage: $('input[name=nextPageURL]').val(),
                            user_id: customerId
                            }
                        );

                       
                    window.datalayer=window.datalayer || []
                    const dl = Array.isArray(window.dataLayer) ? window.dataLayer : [];

                    // Find the latest view_cart with ecommerce.items
                    const latestViewCart = [...dl].reverse().find(
                    e => e && e.event === 'view_cart' && e.ecommerce && Array.isArray(e.ecommerce.items)
                    );

                    // Deep-clone to avoid accidental mutation of the original dataLayer object
                    const viewCartItems = latestViewCart ? JSON.parse(JSON.stringify(latestViewCart.ecommerce.items)) : [];

                     window.dataLayer.push({
                        event: 'select_promotion',
                        ecommerce: {
                        promotion_id: couponID,
                        items: viewCartItems
                        }
                    });

                    //}
                },
            });
        }
    });

// To get dynamically selected attributes for the items
function getSelectedAttributeHtml(selectedAttributes){
    let html = '';
    if(selectedAttributes.length > 0){
        selectedAttributes.forEach(attribute => {
            html += `
                <span class="line-item-attributes ${attribute.displayName} ${attribute.displayName}-${selectedAttributes.UUID}">
                    ${attribute.displayName}
                    <span class="line-item-attributes value">${attribute.displayValue}</span>
                </span>
            `;
        });
    }
    return html;
    }
      // Function to get free freebie product and add to cart line item
function addLineItemDyanmically(item){
        let selectedAttributes = getSelectedAttributeHtml(item.variationAttributes);
        let lineItemHtml = `<div class="product-info py-0 px-0 in-stock uuid-${item.UUID}">
        <div class="cart-product">
            <div class="cart-product-image">
                <div class="item-image shimmer-effect">
                    <a class="link" target="_blank" rel="noreferrer" href="${item.productUrl}">
                        <img
                            width="80px"
                            height="120px"
                            class="product-image"
                            src="${item.images.small[0].url}"
                            alt="${item.images.small[0].alt}"
                            title="${item.images.small[0].title}"
                        />
                        <span class="card-overlay d-none">
                            <strong>${item.availability.messages[0]}</strong>
                        </span>
                    </a>
                </div>
            </div>
            <div class="cart-product-info">
                <div class="row ml-0 mr-2">
                    <div class="col-11 col-md-7 item-attributes">
                        <div class="line-item-header">
                            <div class="line-item-name">
                                <a href="${item.productUrl}">${item.productName}</a>
                            </div>
                            <div>Bonus Product</div>
                        </div>
                        ${selectedAttributes}
                        <div class="price-section d-md-none d-block">
                            <div class="row align-price">
                                <div class="col-12">
                                    <!-- Prices -->
                                    <div class="unit-price prices text-left p-0">
                                    ${item.renderedPrice}
                                    </div>
                                    <div class="line-item-promo mt-1 item-1fbc863cbd46b331a797f3b8f0">
                                        ${item.renderedPromotions}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 col-md-4 price-section d-none d-md-block">
                        <div class="row align-price">
                            <div class="col-12 px-0">
                                <div class="unit-price prices text-left p-0">
                                    ${item.renderedPrice}
                                </div>
                            </div>
                            <div class="line-item-promo mt-1 item-${item.UUID}">
                                ${item.renderedPromotions}
                            </div>
                        </div>
                    </div>
                    <div class="col-1 text-right pl-0 pr-3 price-section"></div>
                </div>
            </div>
        </div>
    </div>`
    return lineItemHtml;  
}

$('body').on('promotion:success', function (e, response) {
        // Add lineitem dynamically to cart page
        const actualItemClasses = [];
        response.items.forEach(function (item) {
            let itemDyanmicClass = `.uuid-${item.UUID}`;
            actualItemClasses.push(`uuid-${item.UUID}`);
            if (!$(itemDyanmicClass).length) {
                let lineItemHtml = addLineItemDyanmically(item);
                $('.cart-product-line-item').append(lineItemHtml);
            }
        });

        // Remove once coupon get removed
        const children = $('.cart-product-line-item').children('.product-info');
        const filteredChildren = children.filter(function () {
            return [...this.classList].some(cls => cls.startsWith('uuid-'));
        });
        const uuidsArray = filteredChildren.map(function () {
            return [...this.classList].find(cls => cls.startsWith('uuid-'));
        }).get();

        const itemsToRemove = uuidsArray.filter(uuid => !actualItemClasses.includes(uuid));
        itemsToRemove.forEach(function (uuid) {
                $(`.product-info.${uuid}`).remove();
            });
    })
};

var cart = require('base/cart/cart');

module.exports = {
    cart: cartModule
};
